





















































































import { Component, Vue, Prop } from "vue-property-decorator";
import PicPreview from "@/components/pic-preview.vue";
@Component({
  components: {
    PicPreview,
  },
})
export default class IdrShouJiqi extends Vue {
  @Prop()
  private current: any;
  private ifShowPicPreview: boolean = false;
  private picUrl: any = "";
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }
  /**
   * @description 打开预览图
   */
  private showPreview(url) {
    this.picUrl = url;
    this.ifShowPicPreview = true;
  }
  private change(e) {
    if (this.current["标注"]["fields"].indexOf("其它") === -1) {
      this.current["标注"]["other"] = "";
    }
  }
  private inputChange(e) {
    if (this.current["标注"]["fields"].indexOf("其它") === -1) {
      this.current["标注"]["fields"].push("其它");
    }
  }
}
